import { get } from "lodash";
import { DefaultRootState } from "react-redux";

export const getSplashIsOpen = (store) =>
  get(store, "locationSplash.isOpen", false);

export const getSplashIsLocationRequired = (store) =>
  get(store, "locationSplash.isLocationRequired", false);
